import BaseSchema from "./base";

class AcquisitionRecordBook extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "acquisitionRecordBooks";
  static fields = [
    "uuid",
    "project",
    "createdAt",
    "updatedAt",
    "label",
    "acquisitionBookCsvUuid",
    "ch4ResponseFactor",
    "analyserBooks",
    "trialsHours",
    "noGraphUuid",
    "noxGraphUuid",
    "coGraphUuid",
    "co2GraphUuid",
    "o2GraphUuid",
    "so2GraphUuid",
    "c3H8GraphUuid",
    "ch4GraphUuid",
    "temperatureGraphUuid",
    "noSamplesGraphsUuids",
    "noxSamplesGraphsUuids",
    "coSamplesGraphsUuids",
    "co2SamplesGraphsUuids",
    "o2SamplesGraphsUuids",
    "so2SamplesGraphsUuids",
    "c3H8SamplesGraphsUuids",
    "ch4SamplesGraphsUuids",
    "temperatureSamplesGraphsUuids",
    "noSamplesConcentrations",
    "noxSamplesConcentrations",
    "coSamplesConcentrations",
    "co2SamplesConcentrations",
    "o2SamplesConcentrations",
    "so2SamplesConcentrations",
    "c3H8SamplesConcentrations",
    "ch4SamplesConcentrations",
    "noxConcentration",
    "coConcentration",
    "co2Concentration",
    "o2Concentration",
    "so2Concentration",
    "c3H8Concentration",
    "ch4Concentration",
    "noConcentration",
    "graphsPoint",
    "settings",
    "isDraft",
  ];

  static relatedFields = {
    analyserBooksObjects: {
      m2m: true,
      tableName: "recordBooks",
      relatedKey: "analyserBooks",
      owner: true,
    },
  };
}

export default AcquisitionRecordBook;
